module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Application for a visa for France")]), _vm._v(" "), _c('p', [_vm._v("\n      You mentioned that you did not apply for a visa yet. ")]), _vm._v(" "), _c('p', [_vm._v("Our lawyers can help you to build your application file and write a cover letter. Ce service est un service premium (999€ TTC). ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n      réalisé une demande de visa\nIf you have made a mistake in your answers and you have already applied for a visa, you can "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("restart our questionnaire")]), _vm._v(".\n    ")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/justice-scale.svg",
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Pour y souscrire, il vous suffit de cliquer sur ce lien suivant : XXX"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Sinon nous vous invitons à effectuer une demande de visa auprès des services consulaires français "), _c('a', {
    attrs: {
      "href": "https://www.service-public.fr/particuliers/vosdroits/N105"
    }
  }, [_vm._v("for more information")]), _vm._v(".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25d49aa6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ScreenDemandeVisa.vue
// module id = 727
// module chunks = 3